module.exports = __webpack_public_path__ + "static/img/0001源咖离线神器.c315f33.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0001源咖离线神器.jpg
// module id = rifz
// module chunks = 0